import styled from "@emotion/styled";
import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";

const Wrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f5f7fa;
  padding: 20px;
`;

export default function Withdraw() {
  const { user } = useSelector((state) => state.user);

  const [amount, setAmount] = useState("");
  const [upi, setUpi] = useState("");

  const handleWithdraw = (e) => {
    e.preventDefault();

    if (!amount || amount < 100) {
      alert("Minimum withdraw is 100");
      return;
    }

    const phoneNumber = "6285217948225"; // 👈 तुम्हारा WhatsApp नंबर

    const message = `💸 Withdrawal Request

👤 User: ${user?.name || "Guest"}
🆔 ID: ${user?._id || "N/A"}

💰 Amount: ₹${amount}
🏦 UPI/QR: ${upi || "Not Provided"}

📌 Please process withdrawal.`;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");
  };

  return (
    <Wrapper>
      <Card
        sx={{
          width: "100%",
          maxWidth: 420,
          borderRadius: 4,
          boxShadow: 6,
          padding: 2,
        }}
      >
        <CardContent>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Withdraw Money
          </Typography>

          <Typography variant="body2" color="text.secondary" mb={2}>
            Enter amount and UPI to withdraw your balance
          </Typography>

          <form onSubmit={handleWithdraw}>
            <TextField
              fullWidth
              label="Withdraw Amount"
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              margin="normal"
              required
            />

            <TextField
              fullWidth
              label="UPI ID / QR Info"
              placeholder="Enter your UPI ID"
              value={upi}
              onChange={(e) => setUpi(e.target.value)}
              margin="normal"
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              sx={{
                mt: 3,
                borderRadius: 2,
                py: 1.5,
                fontSize: 16,
                fontWeight: 700,
                backgroundColor: "#25D366",
                color: "#fff",
              }}
            >
              Withdraw via WhatsApp
            </Button>
          </form>
        </CardContent>
      </Card>
    </Wrapper>
  );
}
